import React from 'react';
import { Table } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import RowActions from './RowActions';

const ACTION_STYLE = { width: '7.25rem' };

const SkeletonRow = ({ columns }) => (
  <tr>
    {columns.map((column) => (
      <td key={column.header} style={column.style}>
        <Skeleton />
      </td>
    ))}
    <td className="text-center" style={ACTION_STYLE}>
      <div className="d-flex flex-column align-items-center">
        <Skeleton style={{ width: '5.625rem' }} />
        <Skeleton className="mt-1" style={{ width: '5.625rem' }} />
        <Skeleton className="mt-1" style={{ width: '5.625rem' }} />
      </div>
    </td>
  </tr>
);

/** Renders `tab.columns` plus the Action column for each row. */
const PoTable = ({ tab, rows, loading, ctx }) => (
  <Table striped bordered responsive hover>
    <thead
      className="font-weight-bold"
      style={{ fontSize: '16px', color: '#505050' }}
    >
      <tr>
        {tab.columns.map((column) => (
          <th key={column.header}>{column.header}</th>
        ))}
        <th>Action</th>
      </tr>
    </thead>
    <tbody style={{ fontSize: '15px' }}>
      {loading &&
        !rows?.length &&
        [0, 1, 2].map((i) => <SkeletonRow key={i} columns={tab.columns} />)}
      {!loading && !rows?.length && (
        <tr>
          <td
            colSpan={tab.columns.length + 1}
            className="text-center text-muted py-4"
          >
            No data for the current filters.
          </td>
        </tr>
      )}
      {rows?.map((po) =>
        loading ? (
          <SkeletonRow key={po.id} columns={tab.columns} />
        ) : (
          <tr key={po.id}>
            {tab.columns.map((column) => (
              <td
                key={column.header}
                className={column.className}
                style={column.style}
              >
                {column.render(po, ctx)}
              </td>
            ))}
            <td className="text-center" style={ACTION_STYLE}>
              <RowActions po={po} ctx={ctx} />
            </td>
          </tr>
        ),
      )}
    </tbody>
  </Table>
);

export default PoTable;
